module.exports = __webpack_public_path__ + "img/38-l.76f5eb47.png";